import {ClaimManagerBackend, ClaimManagerFrontend} from './application-configurations';
import {SupportedLanguage} from '../localization/supported-languages';

export const baseBackendConfiguration: ClaimManagerBackend = {
  baseUrl: '',
  upsertClaimDraftPath: "/api/v1/claims",
  createPresignedUploadUrlsPath: "/api/v1/claims/{claimId}/attachments/{claimFileType}",
  submitClaimPath: "/api/v1/claims/{claimId}/submit",
  createBatchUploadPresignedUploadUrlsPath: "/api/v1/claims/batch-upload/archive-upload-url",
  getAllBatchUploadsPath: "/api/v1/claims/batch-uploads/list",
  getAllClaimsPath: "/api/v1/claims",
  getSearchClaimsByInsuranceClaimReferencePath: "/api/v1/claims/search",
  getDownloadClaimsByInsuranceClaimReferencePath: "/api/v1/claims/batch-download",
  createPresignedDownloadUrlsPath: "/api/v1/claims/{claimId}/report/{fileFormat}",
  putClaimsResultPath: "/api/v1/claims/{claimId}/review-status",
  getMetadataLookupByPolicyNumberPath: "/api/v1/claims/metadata-lookup-by-policy-number",
}

export const baseFrontendConfiguration: ClaimManagerFrontend = {
  baseUrl: 'http://localhost:4200',
  condominiumListPath: "/data/{insuranceCompanyId}/{adjusterCompanyId}/condominiums/condominiums-list.json",
  localisationConfiguration: {
    defaultLanguage: {
      languageId: 'english',
      nativeLanguageName: 'English',
      englishLanguageName: 'English'
    },
    supportedLanguages: [
      {
        languageId: 'english',
        nativeLanguageName: 'English',
        englishLanguageName: 'English'
      },
      {
        languageId: 'german',
        nativeLanguageName: 'Deutsch',
        englishLanguageName: 'German'
      },
      {
        languageId: "thai",
        nativeLanguageName: "ไทย",
        englishLanguageName: "Thai"
      }
    ].sort((a: SupportedLanguage, b: SupportedLanguage) => a.englishLanguageName.localeCompare(b.englishLanguageName)),
    translationsBasePath: '/data/localizations/languages'
  }
}
